var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgNoEvents = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 120,
  height: 120,
  style: {
    background: "#0b1029"
  },
  viewBox: "0 0 120 120"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  strokeWidth: 2
}, /*#__PURE__*/React.createElement("g", {
  stroke: "currentColor"
}, /*#__PURE__*/React.createElement("path", {
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M89 38.978v59.937c0 .6-.582 1.085-1.298 1.085H32.36c-1.304 0-2.36-.884-2.36-1.975v-75.05C30 21.885 31.056 21 32.36 21h41.194z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M73.777 21.186v17.897h15.5"
})), /*#__PURE__*/React.createElement("path", {
  stroke: "#FFF",
  strokeLinejoin: "round",
  d: "M58.533 74.737q2.14 0 3.931-1.032a7.6 7.6 0 0 0 2.822-2.802q1.032-1.772 1.031-3.912a22.9 22.9 0 0 0-.934-6.539q-1.206 1.557-3.308 2.686-1.908 1.011-4.204 1.479-2.18.428-3.367 1.732t-1.187 3.289q0 1.362.701 2.55a5.07 5.07 0 0 0 1.907 1.867 5.2 5.2 0 0 0 2.608.682zM61.453 45q4.865 3.93 7.628 9.458Q72 60.257 72 66.68q0 3.503-1.79 6.539a12.7 12.7 0 0 1-4.671 4.631Q62.54 79.602 59 79.602q-3.541 0-6.539-1.752a12.7 12.7 0 0 1-4.67-4.631A12.65 12.65 0 0 1 46 66.679q0-4.047 1.401-7.823a22.2 22.2 0 0 1 3.853-6.616v.583q0 1.674.76 3.056a5.66 5.66 0 0 0 2.101 2.18q1.343.797 2.978.797t2.9-.798a5.4 5.4 0 0 0 1.965-2.18q.7-1.38.7-3.055 0-1.557-.31-3.58-.234-1.44-.585-2.997z"
}))));
export default SvgNoEvents;